import React, { Fragment, useContext, useEffect, useState } from "react";

import { addDays, addMonths, format } from "date-fns";

// Provider
import { AppContext } from "../../../../components/AppProvider";

// Utils

// UI
import { IC } from "../../../../resources/Assets";
import { AlertPopup, Container, DateLayer, openAlertPopup, openLayerFn } from "../../../Layout";
import { ScrollToTop } from "../../../common/ScrollToTop/ScrollToTop";

// Componene
import { DeleteLayer } from "./Component/DeleteLayer";
import { ListLayer } from "./Component/ListLayer";
import { MealDetailLayer } from "./Component/MealDetailLayer";
import { MemoLayer } from "./Component/MemoLayer";
import { TargetBPLayer } from "./Component/TargetBpLayer";

// Temp Images
import { PostApi1106, PostApi1109 } from "../../../../modules/network/padoPost";
import { NativeAction } from "../../../../modules/utils/HandleWs";
import { PeriodTypeChange, convertFormat } from "../../../../modules/utils/PeriodTypeChange";
import { userHabit } from "../../../../modules/utils/UserHabit";
import { Nothing } from "../../../Reservation/ResrvList";
import { reLogin } from "../../../common/AutoLogin/AutoLogin";
import ModifyLayer from "../ModifyLayer";
import useTitle from "../../../../modules/hooks/useTitle";
const interfaceDateFormat = "yyyyMMdd";

export default props => {
  useTitle("자가건강관리_혈압_이력");
  // userinfo
  const { auth, userinfo, cfg, phonecfg, dispatch } = useContext(AppContext);
  // 필수 state 선언
  const [periodType, setPeriodType] = useState(props.match.params.periodType);
  const [startDate, setStartDate] = useState(
    props.match.params.startDate && props.match.params.startDate == "1"
      ? convertFormat(PeriodTypeChange("year", 1), "yyyyMMdd")
      : props.match.params.startDate
  );
  const [endDate, setEndDate] = useState(
    props.match.params.endDate && props.match.params.endDate == "1"
      ? convertFormat(PeriodTypeChange("year", 0), "yyyyMMdd")
      : props.match.params.endDate
  );

  const [contentsList, setContentsList] = useState(null);
  const [checkedSeqNo, setCheckedSeqNo] = useState("");
  const [trgtMaxBp, setTrgtMaxBp] = useState("");
  const [trgtMinBp, setTrgtMinBp] = useState("");

  const [seqNo, setSeqNo] = useState("");
  const [memo, setMemo] = useState("");

  const [pageNo, setPageNo] = useState(1);
  const [pageCnt, setPageCnt] = useState(500);

  const [displayMod, setDisplayMod] = useState(false);
  const [targetData, setTargetDate] = useState();

  const settingPeriodType = periodIndex => {
    setPeriodType(periodIndex);
  };

  const handleDate = (isStart, date) => {
    if (isStart === "1") {
      setStartDate(date);
    } else {
      setEndDate(date);
    }
  };

  // 전체 선택 기능 추가
  const checkedAll = () => {
    // 체크된 목록과 총 목록을 비교하여 토글식 이벤트 동작
    if (
      checkedSeqNo.length ===
      $("input:checkbox").prop("checked", true).length - 1
    ) {
      unCheckedAll();
    } else {
      $("input:checkbox").prop("checked", true);
      settingSeqNo();
    }
  };

  const unCheckedAll = () => {
    $("input:checkbox").prop("checked", false);
    settingSeqNo();
  };

  const settingSeqNo = () => {
    let checkArr = new Array();

    $("input[name=checkSeqNo]:checked").each(function () {
      checkArr.push($(this).val());
    });

    setCheckedSeqNo(checkArr.length > 0 ? checkArr : []);
  };

  const request1106 = (
    userinfo,
    cfg,
    periodType,
    searchFromDt,
    searchToDt,
    pageNo,
    pageCnt
  ) => {
    let reqStartDate = "";
    let reqEndDate = format(new Date(), interfaceDateFormat);
    switch (periodType) {
      case 1:
        reqStartDate = format(addDays(new Date(), -6), interfaceDateFormat);
        break;
      case 2:
        reqStartDate = format(addMonths(new Date(), -1), interfaceDateFormat);
        break;
      case 3:
        reqStartDate = format(addMonths(new Date(), -3), interfaceDateFormat);
        break;
      default:
        reqStartDate = searchFromDt;
        reqEndDate = searchToDt;
        break;
    }

    if (reqStartDate != "" && reqEndDate != "" && reqStartDate <= reqEndDate) {
      PostApi1106(
        userinfo,
        cfg,
        phonecfg,
        periodType,
        reqStartDate,
        reqEndDate,
        pageNo,
        pageCnt
      )
        .then(res => {
          if (res.resultMsg === "SUCCESS") {
            setContentsList(res.result);
          } else {
            console.log("LOGOUT!!!");
          }
        })
        .catch(err => {
          console.log(err);
        });
    } else {
      if (startDate.length == 8 && endDate.length == 8) {
        if (
          reqStartDate != "" &&
          reqEndDate != "" &&
          reqStartDate > reqEndDate
        ) {
          openAlertPopup("선택한 날짜를 확인하세요.");
        }
      }
    }
  };

  const request1109 = (userinfo, cfg) => {
    PostApi1109(userinfo, phonecfg, cfg)
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          if (res.result != "") {
            setTrgtMaxBp(res.result.maxBp);
            setTrgtMinBp(res.result.minBp);
          }
        } else {
          console.log("LOGOUT!!!");
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const Bottom = (
    <Fragment>
      <div className="allcheck-setting-area">
        <a onClick={unCheckedAll}>
          <i className="clear"></i>선택해제
        </a>
        <a href={void 0} className="btn-check-delete">
          <i className="dele"></i>선택삭제
        </a>
      </div>
      {/* <div className="under-fixarea-emptybox"></div> */}
    </Fragment>
  );

  const reloadList = () => {
    if (periodType === 4) {
      if ($(".pick-num1").val() != "" && $(".pick-num2").val() != "") {
        request1106(
          userinfo,
          cfg,
          periodType,
          startDate,
          endDate,
          pageNo,
          pageCnt
        );
        unCheckedAll();
      } else {
        setContentsList(null);
      }
    } else {
      request1106(
        userinfo,
        cfg,
        periodType,
        startDate,
        endDate,
        pageNo,
        pageCnt
      );
      unCheckedAll();
    }
  };

  let userinfo2 = reLogin(auth, userinfo, dispatch);

  useEffect(() => {
    //기간설정 버튼들
    // $(".date-setting-area .btns a").click(function () {
    //   $(".date-setting-area .btns a").removeClass("on");
    //   $(this).addClass("on");
    //   var idx = $(this).index();
    //   if (idx == 3) {
    //     //직접 기간설정
    //     $(".date-setting-area .date-input").slideDown("fast");
    //   } else {
    //     $(".date-setting-area .date-input").slideUp("fast");
    //   }
    // });

    request1109(userinfo2, cfg);
  }, []);

  useEffect(() => {
    reloadList();
  }, [
    periodType,
    startDate,
    endDate,
    trgtMaxBp,
    trgtMinBp,
    props.match.params,
  ]);

  useEffect(() => {
    if (checkedSeqNo == "") {
      $(".allcheck-setting-area").hide();
      $("#checkboxAll").prop("checked", false);
    } else {
      if (checkedSeqNo.length === contentsList.length) {
        $("#checkboxAll").prop("checked", true);
      } else {
        $("#checkboxAll").prop("checked", false);
      }
      $(".allcheck-setting-area").show();
    }
  }, [checkedSeqNo]);

  const checkAllStatus = () => {
    if (checkedSeqNo != "" && checkedSeqNo.length == contentsList.length) {
      return true;
    } else {
      return false;
    }
  };

  useEffect(() => {
    userHabit(phonecfg, "BP131");
    NativeAction(phonecfg, "statusColor", "#7FD2C2");
  }, [phonecfg.version]);

  return (
    <Fragment>
      <ScrollToTop />
      <Container
        Title="혈압/심박수 목록"
        bottom={Bottom}
        color="green"
        goToUrl={
          periodType === 4
            ? "/sm/bp" + "/" + periodType + "/" + startDate + "/" + endDate
            : "/sm/bp" + "/" + periodType + "/1/1"
        }>
        <div className="contents sub">
          <div className="sub-contents" style={{ padding: "0px 16px 28px" }}>
            {/* 공백? */}
            <div className="blank20" style={{ height: "20px" }}></div>
            {/* 공백? */}

            {/* 목표혈압 */}
            <div
              className="m-section my-hospital-list"
              style={{ padding: "0px" }}>
              <div className="main-section-title">
                목표혈압
                <div
                  className="subtxt_btn"
                  onClick={() => openLayerFn($(".bloodgoal-layer"))}>
                  목표혈압설정
                </div>
                <a
                  className="btn-myset btn1"
                  onClick={() => openLayerFn($(".bloodgoal-layer"))}></a>
              </div>

              <div className="page-bloodpressure-card01">
                <ul style={{ padding: "0px 16px" }}>
                  <li>
                    <table>
                      <tbody>
                        <tr>
                          <td
                            rowSpan="2"
                            alt="icon_compress"
                            className="goal_img">
                            <img
                              src={IC.bp.IC_MAX_BP}
                              width="28em"
                              style={{ verticalAlign: "middle" }}
                            />
                          </td>
                          <td
                            alt="title"
                            className="goal_index"
                            style={{ height: "1.8rem" }}>
                            수축기
                          </td>
                          <td
                            rowSpan="2"
                            alt="value"
                            className="goal_bignum_red">
                            {trgtMaxBp !== 9999
                              ? trgtMaxBp != 0
                                ? trgtMaxBp
                                : "135"
                              : "135"}
                          </td>
                          <td></td>
                          <td
                            rowSpan="2"
                            alt="icon_expand"
                            className="goal_img">
                            <img
                              src={IC.bp.IC_MIN_BP}
                              width="28em"
                              style={{ verticalAlign: "middle" }}
                            />
                          </td>
                          <td
                            alt="title"
                            className="goal_index"
                            style={{ height: "1.8rem" }}>
                            이완기
                          </td>
                          <td
                            rowSpan="2"
                            alt="value"
                            className="goal_bignum_blue">
                            {trgtMinBp !== 9999
                              ? trgtMinBp != 0
                                ? trgtMinBp
                                : "85"
                              : "85"}
                          </td>
                        </tr>
                        <tr>
                          <td className="goal_index_caption">최고혈압</td>
                          <td></td>
                          <td className="goal_index_caption">최소혈압</td>
                        </tr>
                      </tbody>
                    </table>
                  </li>
                </ul>
              </div>
            </div>
            {/* 목표혈압 */}

            <SectionTitle title="기간 선택" style={{ marginTop: "32px" }} />

            <div className="date-setting-area">
              <div className="btns">
                <a
                  onClick={() => setPeriodType(1)}
                  className={periodType == 1 ? "on" : ""}
                  style={{ width: "23%", height: "36px", marginRight: "2.5%" }}>
                  1주일
                </a>
                <a
                  onClick={() => setPeriodType(2)}
                  className={periodType == 2 ? "on" : ""}
                  style={{ width: "23%", height: "36px", marginRight: "2.5%" }}>
                  1개월
                </a>
                <a
                  onClick={() => setPeriodType(3)}
                  className={periodType == 3 ? "on" : ""}
                  style={{ width: "23%", height: "36px", marginRight: "2.5%" }}>
                  3개월
                </a>
                <a
                  onClick={() => setPeriodType(4)}
                  // className={
                  //   periodType == 4 ? "btn-selfinput on" : "btn-selfinput"
                  // }
                  className={`btn-selfinput ${periodType == 4 ? "on" : ""}`}
                  style={{ width: "23%", height: "36px", marginRight: "0" }}>
                  기간설정
                </a>
              </div>
              <div
                className="date-input"
                style={
                  periodType == 4 ? { display: "block" } : { display: "none" }
                }>
                <div className="round-bar">
                  <div className="ipbox">
                    <input
                      type="text"
                      placeholder="선택하세요."
                      readOnly
                      className="date-picker-input pick-num1"
                      data-num="1"
                      defaultValue={
                        props.match.params.periodType == "4" &&
                        startDate.length == 8
                          ? startDate.substring(0, 4) +
                            "." +
                            startDate.substring(4, 6) +
                            "." +
                            startDate.substring(6, 8)
                          : ""
                      }
                    />
                    <i></i>
                  </div>
                  <u>~</u>
                  <div className="ipbox">
                    <input
                      type="text"
                      placeholder="선택하세요."
                      readOnly
                      className="date-picker-input pick-num2"
                      data-num="2"
                      defaultValue={
                        props.match.params.periodType == "4" &&
                        endDate.length == 8
                          ? endDate.substring(0, 4) +
                            "." +
                            endDate.substring(4, 6) +
                            "." +
                            endDate.substring(6, 8)
                          : ""
                      }
                    />
                    <i></i>
                  </div>
                </div>
              </div>
            </div>
            {contentsList != null && (
              <Fragment>
                {contentsList.length > 0 ? (
                  <ListLayer
                    checkedAll={checkedAll}
                    contentsList={contentsList}
                    settingSeqNo={settingSeqNo}
                    setSeqNo={setSeqNo}
                    setMemo={setMemo}
                    setTargetDate={setTargetDate}
                    setDisplayMod={setDisplayMod}
                  />
                ) : (
                  <Nothing text="입력된 내역이 없습니다." />
                )}
              </Fragment>
            )}
          </div>
        </div>
      </Container>
      <TargetBPLayer
        trgtMaxBp={trgtMaxBp}
        trgtMinBp={trgtMinBp}
        setTrgtMaxBp={setTrgtMaxBp}
        setTrgtMinBp={setTrgtMinBp}
      />
      <MealDetailLayer />
      <MemoLayer
        seqNo={seqNo}
        memo={memo}
        reloadList={reloadList}
        openAlertPopup={openAlertPopup}
      />
      <DeleteLayer
        seqNo={checkedSeqNo}
        setContentsList={setContentsList}
        reloadList={reloadList}
        periodType={periodType}
        startDate={startDate}
        endDate={endDate}
      />
      <DateLayer handleDate={handleDate} color="green" />
      <AlertPopup />
      {displayMod && (
        <ModifyLayer
          setDisplayMod={setDisplayMod}
          reloadList={reloadList}
          seqNo={seqNo}
          targetData={targetData}
        />
      )}
    </Fragment>
  );
};

export const SectionTitle = (props) => {
  return (
    <div className="section-box" style={props.style}>
      <div className="main-section-title">{props.title}</div>
    </div>
  );
};
